export default __webpack_public_path__ + "static/media/bg-picture-info-block-full.571e6f99.png";